'use client';

import Link from 'next/link';
import { useState, useEffect } from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [native, setNative] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cap = (window as any).Capacitor;
    if (cap?.isNativePlatform?.()) {
      setNative(true);
    }
  }, []);

  // Hide footer entirely on native — navigation is via bottom tab bar,
  // legal links are in Settings > About
  if (native) return null;

  return (
    <footer className="border-t border-border mt-16">
      <div className="container mx-auto px-4 py-8">
        {/* Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-3">The Art of CTO</h3>
            <p className="text-foreground-secondary text-sm mb-4">
              Building systems. Leading people.
            </p>
            <p className="text-foreground-secondary text-sm">
              Timely insights. Timeless frameworks.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/insights" className="text-foreground-secondary hover:text-accent transition-colors">
                  Insights
                </Link>
              </li>
              <li>
                <Link href="/frameworks" className="text-foreground-secondary hover:text-accent transition-colors">
                  Frameworks
                </Link>
              </li>
              <li>
                <Link href="/comparisons" className="text-foreground-secondary hover:text-accent transition-colors">
                  Comparisons
                </Link>
              </li>
              <li>
                <Link href="/code" className="text-foreground-secondary hover:text-accent transition-colors">
                  Code Samples
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-foreground-secondary hover:text-accent transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-foreground-secondary hover:text-accent transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal (& Feeds on web only) */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-3">
              {native ? 'Legal' : 'Legal & Feeds'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/privacy" className="text-foreground-secondary hover:text-accent transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-foreground-secondary hover:text-accent transition-colors">
                  Terms of Service
                </Link>
              </li>
              {/* RSS/Atom feeds are not useful in native apps */}
              {!native && (
                <>
                  <li>
                    <Link href="/feed.xml" className="text-foreground-secondary hover:text-accent transition-colors">
                      RSS Feed
                    </Link>
                  </li>
                  <li>
                    <Link href="/atom.xml" className="text-foreground-secondary hover:text-accent transition-colors">
                      Atom Feed
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-foreground-secondary">
          <p>&copy; {currentYear} The Art of CTO. All rights reserved.</p>
          <p>Made for CTOs, by CTOs</p>
        </div>
      </div>
    </footer>
  );
}
